import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import PropTypes from 'prop-types';

// Components
import MyButton from '../../utils/MyButton';
import DeleteScream from './DeleteScream';
import ScreamDialog from './ScreamDialog';
import LikedButton from './LikedButton';

// Redux
import { connect } from 'react-redux';

// MUI stuff
import { withStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

//Icons
import ChatIcon from '@mui/icons-material/Chat';

const styles = {
    card: {
        position: 'relative',
        display: 'flex',
        marginBottom: 16,
        borderRadius: 8
    },
    image: {
        minWidth: 150,
        maxWidth: 150,
        objectFit: 'cover'
    },
    content: {
        padding: '12px 16px',
        flex: 1
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    actionsRow: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 8
    }
}

class Scream extends Component {

    render() {
        dayjs.extend(relativeTime);
        const {
            classes,
            scream: {
                screamId,
                likeCount,
                body,
                commentCount,
                createdAt,
                userHandle,
                userImage
            },
            user: {
                authenticated,
                credentials: { handle }
            }
        } = this.props;

        const deleteButton = authenticated && userHandle === handle
            ? <DeleteScream screamId={screamId} /> : null

        return (
            <Card className={classes.card}>
                <CardMedia
                    image={userImage}
                    title="Profile Image"
                    className={classes.image} />
                <CardContent className={classes.content}>
                    <div className={classes.header}>
                        <Typography
                            variant="h5"
                            component={Link}
                            to={`/users/${userHandle}`}
                            color="primary">
                            {userHandle}
                        </Typography>
                        {deleteButton}
                    </div>
                    <Typography
                        variant="body2"
                        color="text.secondary">
                        {dayjs(createdAt).fromNow()}
                    </Typography>
                    <Typography variant="body1" style={{ marginTop: 6, marginBottom: 4 }}>{body}</Typography>
                    <div className={classes.actionsRow}>
                        <LikedButton screamId={screamId} />
                        <Typography variant="body2" component="span" style={{ marginRight: 12 }}>
                            {likeCount} Likes
                        </Typography>
                        <MyButton tip="Comments">
                            <ChatIcon color="primary" />
                        </MyButton>
                        <Typography variant="body2" component="span" style={{ marginRight: 12 }}>
                            {commentCount} Comments
                        </Typography>
                        <ScreamDialog
                            screamId={screamId}
                            userHandle={userHandle}
                            openDialog={this.props.openDialog} />
                    </div>
                </CardContent>
            </Card>
        )
    }
}

Scream.propTypes = {
    user: PropTypes.object.isRequired,
    scream: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    openDialog: PropTypes.bool
}

const mapStateToProps = state => ({
    user: state.user
});

export default connect(mapStateToProps)(withStyles(styles)(Scream));
